import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const PracticeTeamFormContainer = ({ className, children, ...props }) => (
  <div
    {...props}
    className={classNames(className, styles.practiceTeamFormContainer)}
    data-testid="practice-team-form-container"
  >
    <div
      className={styles.practiceTeamFormContainerInner}
      data-testid="practice-team-form-container-inner"
    >
      {children}
    </div>
  </div>
);

PracticeTeamFormContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PracticeTeamFormContainer.displayName = "PracticeTeamFormContainer";

export default PracticeTeamFormContainer;
